import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PlatformService } from "../platform/platform.service";
import { GlobalConstants } from "@src/app/global-constants";
import { Observable } from "rxjs";

@Injectable()
export class NewsletterService {
  private readonly API_URL: any;
  private readonly API_SHARED_URL: any;
  private readonly constantesGlobales: any;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly platformService: PlatformService,
  ) {
    const host = this.platformService.getLocationHostname();
    this.constantesGlobales = new GlobalConstants(host);
    this.API_URL = this.constantesGlobales.urlApi;
    this.API_SHARED_URL = this.constantesGlobales.urlSharedApi;
  }

  /**
   * Envía una solicitud POST para registrar un correo electrónico en el boletín informativo.
   *
   * @param email - Dirección de correo electrónico del usuario que se desea registrar.
   * @returns Un observable que emite la respuesta de la solicitud HTTP.
   *
   * @remarks
   * Este método utiliza un encabezado con el tipo de contenido `application/x-www-form-urlencoded`
   * y espera una respuesta en formato JSON. El cuerpo de la solicitud incluye el correo electrónico
   * proporcionado y un identificador de ámbito (`idAmbito`) definido en las constantes globales.
   *
   * @example
   * ```typescript
   * this.noticiasService.postUserNewsletter('usuario@example.com').subscribe(response => {
   *   console.log('Registro exitoso:', response);
   * });
   * ```
   */
  public postUserNewsletter(email: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    const body = {
      email,
      idAmbito: this.constantesGlobales.idAmbito,
    };

    return this.httpClient.post<any>(this.API_URL + "/postUserNewsletter", body, { headers: headers });
  }
}
